import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorKycId = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M22.75 19A1.75 1.75 0 0 1 21 20.75H3A1.75 1.75 0 0 1 1.25 19V5c0-.966.784-1.75 1.75-1.75h18c.967 0 1.75.784 1.75 1.75v14Zm-1.75.25a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25h18Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12.75 11a.75.75 0 0 1-.75.75H5a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 .75.75ZM19.75 8a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75ZM12.75 16a.75.75 0 0 1-.75.75H5a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 .75.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorKycId;
